import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DriveCompareUiService } from '../../../shared/drive/drive-compare-ui.service';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

/**
 * Top-nav toggle that starts/exits compare inside the embedded drive explorer.
 * Self-gating: `showCompareToggle` is only true while a drive surface is alive
 * and comparing is possible or active.
 */
@Component({
  selector: 'mtm-top-nav-drive-compare-btn',
  standalone: true,
  providers: [TranslatePipe],
  templateUrl: './top-nav-drive-compare-btn.component.html',
  styleUrl: './top-nav-drive-compare-btn.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopNavDriveCompareBtnComponent {
  private readonly translate = inject(TranslatePipe);
  protected readonly compareUi = inject(DriveCompareUiService);

  protected get toggleTitle(): string {
    return this.translate.transform(this.compareUi.compareActive() ? 'drive_compareExit' : 'drive_compareStart');
  }

  protected onToggle(): void {
    this.compareUi.toggleCompare();
  }
}
